import { Enum } from './Enum';

export class IncidentExternalReporter extends Enum {
  translationKey = 'incidentExternalReporter';

  static asArray: IncidentExternalReporter[] = [];

  static byKey: { [name: string]: IncidentExternalReporter } = {};

  static readonly BAMBOO = new IncidentExternalReporter('BAMBOO');

  static readonly CAREPORT = new IncidentExternalReporter('CAREPORT');

  static readonly CCA = new IncidentExternalReporter('CCA');

  static readonly CINQ = new IncidentExternalReporter('CINQ');

  static readonly ECW = new IncidentExternalReporter('ECW');

  static readonly PERS_ASG = new IncidentExternalReporter('PERS_ASG');

  static readonly PERS_C24 = new IncidentExternalReporter('PERS_C24');

  static readonly PERS_MG = new IncidentExternalReporter('PERS_MG');

  constructor(public readonly value: string) {
    super();
    IncidentExternalReporter.asArray.push(this);
    IncidentExternalReporter.byKey[value] = this;
  }
}

export default IncidentExternalReporter;
